document.addEventListener("DOMContentLoaded", () => {
    const same_products = JSON.parse(document.querySelector("script[data-same-product]")?.textContent || '{"products":[]}');
    const products = same_products.products || [];
    const pageHandle = products[0]?.handle || '';

    const custom_variant_content = document.querySelector(".custom-variant-selector-content");
    if (!custom_variant_content) return;

    const right_selectors = custom_variant_content.querySelectorAll(".right-eye-variant-selector select[data-type='option']");
    const left_selectors = custom_variant_content.querySelectorAll(".left-eye-variant-selector select[data-type='option']");
    const right_krzywizna = custom_variant_content.querySelector(".right-eye-variant-selector select[data-type='krzywizna']");
    const left_krzywizna = custom_variant_content.querySelector(".left-eye-variant-selector select[data-type='krzywizna']");
    const right_srednica = custom_variant_content.querySelector(".right-eye-variant-selector select[data-type='srednica']");
    const left_srednica = custom_variant_content.querySelector(".left-eye-variant-selector select[data-type='srednica']");
    const right_axis = custom_variant_content.querySelector(".right-eye-variant-selector select[data-type='axis']");
    const left_axis = custom_variant_content.querySelector(".left-eye-variant-selector select[data-type='axis']");
    const right_cylinder = custom_variant_content.querySelector(".right-eye-variant-selector select[data-type='cylinder']");
    const left_cylinder = custom_variant_content.querySelector(".left-eye-variant-selector select[data-type='cylinder']");
    const right_input = document.querySelector('#right-variant-id');
    const left_input = document.querySelector("#left-variant-id");
    const is_both = document.querySelector("#is-both");
    const availability_element = document.querySelector("#custom-availability-value");
    const right_quantity_element = custom_variant_content.querySelector(".right-eye-variant-selector select[data-type='quantity']");
    const left_quantity_element = custom_variant_content.querySelector(".left-eye-variant-selector select[data-type='quantity']");

    let right_values = {};
    let left_values = {};
    let right_availability = "";
    let left_availability = "";
    let right_selected_variant = null;
    let left_selected_variant = null;
    let selectVariantSeq = { right: 0, left: 0 };
    const pendingSelect = { right: Promise.resolve(), left: Promise.resolve() };
    const optionsCache = {};
    const productJsCache = {};

    const METAFIELD_KEYS = ['axis', 'cylinder', 'krzywizna', 'srednica'];

    const normalize = (value) => String(value ?? '').trim();
    const valuesEqual = (a, b) => {
        const na = normalize(a);
        const nb = normalize(b);
        if (na === nb) return true;
        if (na !== '' && nb !== '' && !Number.isNaN(Number(na)) && !Number.isNaN(Number(nb))) {
            return Number(na) === Number(nb);
        }
        return na.toLowerCase() === nb.toLowerCase();
    };

    const getRoutesRoot = () => window.Shopify?.routes?.root || '/';
    const productPath = (productData) => {
        if (productData?.handle) return `${getRoutesRoot()}products/${productData.handle}`;
        return productData?.product_url || null;
    };

    const parseJsonFromHtml = (html) => {
        if (!html) return null;
        // Prefer dedicated JSON script tag if present
        try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const script = doc.querySelector('script[type="application/json"]');
            if (script?.textContent) return JSON.parse(script.textContent.trim());
        } catch (e) {}

        const trimmed = String(html).trim();
        try {
            return JSON.parse(trimmed);
        } catch (e) {
            const start = trimmed.indexOf('{');
            const end = trimmed.lastIndexOf('}');
            if (start >= 0 && end > start) {
                try {
                    return JSON.parse(trimmed.slice(start, end + 1));
                } catch (e2) {
                    return null;
                }
            }
        }
        return null;
    };

    const getMetafieldSelectors = (side) => ({
        axis: side === 'right' ? right_axis : left_axis,
        cylinder: side === 'right' ? right_cylinder : left_cylinder,
        krzywizna: side === 'right' ? right_krzywizna : left_krzywizna,
        srednica: side === 'right' ? right_srednica : left_srednica
    });

    const getActiveMetafieldKeys = (metafieldSelectors) =>
        METAFIELD_KEYS.filter((key) => Boolean(metafieldSelectors[key]));

    const productMatchesMetafields = (productData, values, activeKeys) => {
        if (!productData) return false;
        if (!activeKeys.length) return true;
        return activeKeys.every((key) => valuesEqual(productData[key], values[key]));
    };

    const findProductByMetafields = (values, activeKeys) => {
        if (!activeKeys.length) return products[0] || null;
        return products.find((p) => productMatchesMetafields(p, values, activeKeys)) || products[0] || null;
    };

    const resolveMatchedProduct = (values, activeKeys, metafieldSelectors, changedKey = null) => {
        let matched = findProductByMetafields(values, activeKeys);
        if (matched) return matched;

        if (changedKey && normalize(values[changedKey])) {
            const candidates = products.filter((p) => valuesEqual(p[changedKey], values[changedKey]));
            if (candidates.length) {
                candidates.sort((a, b) => {
                    const score = (p) => activeKeys.filter((key) =>
                        key !== changedKey && valuesEqual(p[key], values[key])
                    ).length;
                    return score(b) - score(a);
                });
                matched = candidates[0];
                activeKeys.forEach((key) => {
                    if (key === changedKey) return;
                    values[key] = normalize(matched[key]);
                    if (metafieldSelectors[key]) metafieldSelectors[key].value = values[key];
                });
                return matched;
            }
        }
        return products[0] || null;
    };

    const compareOptionLabels = (a, b) =>
        String(a ?? '').localeCompare(String(b ?? ''), undefined, { numeric: true, sensitivity: 'base' });

    const sortSelectOptions = (selector) => {
        if (!selector?.options?.length) return;
        const selectedValue = selector.value;
        const options = Array.from(selector.options);
        options.sort((a, b) => {
            const aLabel = a.getAttribute('data-option-name') || a.textContent || a.value;
            const bLabel = b.getAttribute('data-option-name') || b.textContent || b.value;
            return compareOptionLabels(aLabel, bLabel);
        });
        selector.innerHTML = '';
        options.forEach((option) => selector.appendChild(option));
        if (selectedValue) selector.value = selectedValue;
    };

    const sortOptionValueMetas = (values) =>
        [...(values || [])].sort((a, b) => compareOptionLabels(a?.name, b?.name));

    const getUniqueMetafieldValues = (fieldKey) => {
        const uniqueValues = new Set();
        products.forEach((p) => {
            const value = normalize(p[fieldKey]);
            if (value) uniqueValues.add(value);
        });
        return Array.from(uniqueValues).sort(compareOptionLabels);
    };

    const populateMetafieldSelector = (selector, fieldKey) => {
        if (!selector) return;
        const uniqueValues = getUniqueMetafieldValues(fieldKey);
        if (!uniqueValues.length) return;
        const previousValue = selector.value;
        selector.innerHTML = '';
        uniqueValues.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            selector.appendChild(option);
        });
        const exact = uniqueValues.find((v) => v === previousValue);
        const loose = uniqueValues.find((v) => valuesEqual(v, previousValue));
        selector.value = exact || loose || uniqueValues[0];
    };

    const populateAllMetafieldSelectors = () => {
        [
            [right_axis, 'axis'], [left_axis, 'axis'],
            [right_cylinder, 'cylinder'], [left_cylinder, 'cylinder'],
            [right_krzywizna, 'krzywizna'], [left_krzywizna, 'krzywizna'],
            [right_srednica, 'srednica'], [left_srednica, 'srednica']
        ].forEach(([selector, key]) => populateMetafieldSelector(selector, key));
    };

    const readCurrentValuesFromDom = (side, values) => {
        const selectors = side === 'right' ? right_selectors : left_selectors;
        const metafieldSelectors = getMetafieldSelectors(side);

        values.optionValueIds = [];
        // reset option1..3
        delete values.option1;
        delete values.option2;
        delete values.option3;

        if (selectors) {
            selectors.forEach((selector) => {
                const selected = selector.selectedOptions?.[0];
                const position = Number(selector.getAttribute('data-position')) || 1;
                const optionName = normalize(
                    selected?.getAttribute('data-option-name') || selected?.textContent || ''
                );
                const optionValueId = selected?.value || '';

                values[`option${position}`] = optionName;
                if (optionValueId && /^\d+$/.test(String(optionValueId))) {
                    values.optionValueIds.push(String(optionValueId));
                }
            });
        }

        // Keep IDs aligned to option positions (sorted by position)
        if (selectors?.length) {
            const ordered = Array.from(selectors).sort(
                (a, b) => Number(a.getAttribute('data-position')) - Number(b.getAttribute('data-position'))
            );
            values.optionValueIds = ordered
                .map((selector) => selector.selectedOptions?.[0]?.value)
                .filter((id) => id && /^\d+$/.test(String(id)))
                .map(String);
        }

        METAFIELD_KEYS.forEach((key) => {
            if (metafieldSelectors[key]) values[key] = metafieldSelectors[key].value;
        });
    };

    const ensureProductOptions = async (productData) => {
        if (!productData) return productData;
        const hasIds = (productData.options || []).some((opt) =>
            (opt.values || []).some((v) => v?.id != null && v?.id !== '')
        );
        if (hasIds) return productData;

        const handle = productData.handle;
        if (!handle) return productData;
        if (optionsCache[handle]) {
            productData.options = optionsCache[handle];
            return productData;
        }

        try {
            const url = `${getRoutesRoot()}products/${handle}?section_id=cv-variant-options`;
            const response = await fetch(url);
            if (!response.ok) return productData;
            const data = parseJsonFromHtml(await response.text());
            if (data?.options?.length) {
                optionsCache[handle] = data.options;
                productData.options = data.options;
            }
        } catch (error) {
            console.warn('ensureProductOptions failed', error);
        }
        return productData;
    };

    // Only rebuild option dropdowns when switching to a different sibling product
    const rebuildOptionSelectorsForProduct = async (selectors, productData, values) => {
        if (!selectors?.length || !productData) return;
        await ensureProductOptions(productData);

        const options = [...(productData.options || [])].sort(
            (a, b) => Number(a.position) - Number(b.position)
        );
        if (!options.length) return;

        Array.from(selectors).forEach((selector) => {
            const position = Number(selector.getAttribute('data-position')) || 1;
            const optionMeta = options.find((o) => Number(o.position) === position);
            if (!optionMeta?.values?.length) return;

            const previousName = normalize(
                values[`option${position}`] ||
                selector.selectedOptions?.[0]?.getAttribute('data-option-name') ||
                selector.selectedOptions?.[0]?.textContent ||
                ''
            );

            selector.innerHTML = '';
            let matchedId = null;
            const sortedValues = sortOptionValueMetas(optionMeta.values);

            sortedValues.forEach((valueMeta) => {
                const name = normalize(valueMeta.name);
                const option = document.createElement('option');
                option.value = valueMeta.id != null ? valueMeta.id : name;
                option.textContent = name;
                option.setAttribute('data-option-name', name);
                if (valuesEqual(name, previousName)) {
                    matchedId = option.value;
                    option.selected = true;
                }
                selector.appendChild(option);
            });

            if (matchedId != null) {
                selector.value = matchedId;
                values[`option${position}`] = previousName;
            } else if (sortedValues[0]) {
                const first = sortedValues[0];
                selector.value = first.id != null ? first.id : normalize(first.name);
                values[`option${position}`] = normalize(first.name);
            }
        });
    };

    const findVariantOnProduct = (productData, values) => {
        if (!productData?.variants?.length) return null;
        return productData.variants.find((variant) => {
            for (let i = 1; i <= 3; i++) {
                const selected = values[`option${i}`];
                if (!selected) continue;
                if (!valuesEqual(variant[`option${i}`], selected)) return false;
            }
            return Boolean(values.option1 || values.option2 || values.option3);
        }) || null;
    };

    const toVariantResult = (data) => ({
        variant_id: String(data.variant_id || data.id),
        available: Boolean(data.available),
        inventory_quantity: Number(data.inventory_quantity) || 0,
        option1: data.option1,
        option2: data.option2,
        option3: data.option3,
        variant_availability: data.variant_availability || ''
    });

    const lookupViaSectionId = async (productData, optionValueIds) => {
        const path = productPath(productData);
        if (!path || !optionValueIds?.length) return null;
        const idsParam = optionValueIds.join(',');

        // Same pattern as theme.js VariantPicker: section_id + option_values
        const url = `${path}?option_values=${idsParam}&section_id=cv-variant-lookup`;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.warn('section_id lookup HTTP', response.status, url);
                return null;
            }
            const html = await response.text();
            const data = parseJsonFromHtml(html);
            if (!data?.variant_id) {
                console.warn('cv-variant-lookup miss', { url, htmlPreview: html.slice(0, 200), optionValueIds });
                return null;
            }
            return toVariantResult(data);
        } catch (error) {
            console.warn('lookupViaSectionId failed', error);
            return null;
        }
    };

    const loadProductJs = async (handle) => {
        if (!handle) return null;
        if (productJsCache[handle]) return productJsCache[handle];
        const response = await fetch(`${getRoutesRoot()}products/${handle}.js`);
        if (!response.ok) return null;
        const data = await response.json();
        productJsCache[handle] = data;
        return data;
    };

    const lookupViaProductJs = async (productData, values) => {
        try {
            const data = await loadProductJs(productData?.handle);
            if (!data?.variants?.length) return null;

            const match = data.variants.find((variant) => {
                const opts = variant.options || [variant.option1, variant.option2, variant.option3];
                if (values.option1 && !valuesEqual(opts[0], values.option1)) return false;
                if (values.option2 && !valuesEqual(opts[1], values.option2)) return false;
                if (values.option3 && !valuesEqual(opts[2], values.option3)) return false;
                return true;
            });
            if (!match) return null;
            return toVariantResult({
                variant_id: match.id,
                available: match.available,
                inventory_quantity: match.inventory_quantity,
                option1: match.option1,
                option2: match.option2,
                option3: match.option3
            });
        } catch (error) {
            console.warn('lookupViaProductJs failed', error);
            return null;
        }
    };

    const mapNamesToOptionValueIds = async (productData, values) => {
        await ensureProductOptions(productData);
        const options = [...(productData.options || [])].sort(
            (a, b) => Number(a.position) - Number(b.position)
        );
        if (!options.length) return null;

        const ids = [];
        for (const option of options) {
            const selectedName = values[`option${option.position}`];
            const match = (option.values || []).find((v) => valuesEqual(v.name, selectedName));
            if (!match?.id) return null;
            ids.push(String(match.id));
        }
        return ids;
    };

    const updateOptionAvailability = async (side, changedKey = null) => {
        const selectors = side === 'right' ? right_selectors : left_selectors;
        const values = side === 'right' ? right_values : left_values;
        const metafieldSelectors = getMetafieldSelectors(side);
        const activeKeys = getActiveMetafieldKeys(metafieldSelectors);

        readCurrentValuesFromDom(side, values);
        const previousHandle = values._matchedHandle || pageHandle;
        const matchedProduct = resolveMatchedProduct(values, activeKeys, metafieldSelectors, changedKey);
        values._matchedHandle = matchedProduct?.handle || pageHandle;

        // Only rebuild Shopify option dropdowns when the matched sibling product changes
        if (
            matchedProduct &&
            matchedProduct.handle &&
            matchedProduct.handle !== previousHandle &&
            matchedProduct.handle !== pageHandle
        ) {
            await rebuildOptionSelectorsForProduct(selectors, matchedProduct, values);
            readCurrentValuesFromDom(side, values);
        } else if (
            matchedProduct &&
            matchedProduct.handle &&
            matchedProduct.handle !== pageHandle &&
            changedKey
        ) {
            await rebuildOptionSelectorsForProduct(selectors, matchedProduct, values);
            readCurrentValuesFromDom(side, values);
        }

        return matchedProduct;
    };

    const updateQuantitySelector = (variant, quantity_selector) => {
        if (!variant || !quantity_selector) return;
        const stock = Number(variant.inventory_quantity);
        const maxQuantity = stock > 0 ? Math.min(stock, 10) : (variant.available ? 10 : 0);
        const currentValue = parseInt(quantity_selector.value, 10) || 1;
        quantity_selector.innerHTML = '';
        for (let i = 1; i <= maxQuantity; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i === Math.min(currentValue, maxQuantity)) option.selected = true;
            quantity_selector.appendChild(option);
        }
        if (maxQuantity === 0) {
            const option = document.createElement('option');
            option.value = 0;
            option.textContent = 'Niedostępne';
            option.disabled = true;
            option.selected = true;
            quantity_selector.appendChild(option);
        }
    };

    const change_into_hours = (value) => {
        if (typeof value !== 'string') return 0;
        const lowerValue = value.toLowerCase();
        if (lowerValue.includes('day') || lowerValue.includes('dni') || lowerValue.includes('dzień')) {
            return parseInt(value, 10) * 24;
        }
        return parseInt(value, 10) || 0;
    };

    const updateAvailabilityDisplay = () => {
        if (!availability_element) return;
        const rightHours = change_into_hours(right_availability);
        const leftHours = change_into_hours(left_availability);
        if (rightHours > leftHours) availability_element.innerHTML = right_availability;
        else if (leftHours > rightHours) availability_element.innerHTML = left_availability;
        else availability_element.innerHTML = right_availability || left_availability || '';
    };

    const applySelectedVariant = (variant, side) => {
        const input = side === 'right' ? right_input : left_input;
        const quantity_selector = side === 'right' ? right_quantity_element : left_quantity_element;

        if (variant?.variant_id && input) {
            input.value = variant.variant_id;
            if (side === 'right') {
                right_selected_variant = variant;
                right_availability = variant.variant_availability || '';
            } else {
                left_selected_variant = variant;
                left_availability = variant.variant_availability || '';
            }
            updateQuantitySelector(variant, quantity_selector);
            console.log(`Resolved ${side} variant`, variant);
        } else {
            if (input) input.value = '';
            if (side === 'right') {
                right_selected_variant = null;
                right_availability = '';
            } else {
                left_selected_variant = null;
                left_availability = '';
            }
            console.warn(`No variant resolved for ${side}`);
        }
        updateAvailabilityDisplay();
    };

    const selectionsEqual = (a, b) => {
        for (let i = 1; i <= 3; i++) {
            if (!valuesEqual(a[`option${i}`], b[`option${i}`])) return false;
        }
        return METAFIELD_KEYS.every((key) => valuesEqual(a[key], b[key]));
    };

    const selectVariant = async (values, side) => {
        const seq = ++selectVariantSeq[side];
        const metafieldSelectors = getMetafieldSelectors(side);
        const activeKeys = getActiveMetafieldKeys(metafieldSelectors);
        const matchedProduct = findProductByMetafields(values, activeKeys) || products[0] || null;

        if (!matchedProduct) {
            applySelectedVariant(null, side);
            return;
        }

        // If both eyes share the same selection and the other side already resolved, reuse it
        if (side === 'right' && left_selected_variant && selectionsEqual(values, left_values)) {
            applySelectedVariant(left_selected_variant, 'right');
            return;
        }
        if (side === 'left' && right_selected_variant && selectionsEqual(values, right_values)) {
            applySelectedVariant(right_selected_variant, 'left');
            return;
        }

        let variant = findVariantOnProduct(matchedProduct, values);

        if (!variant && values.optionValueIds?.length) {
            variant = await lookupViaSectionId(matchedProduct, values.optionValueIds);
        }

        if (!variant) {
            const mappedIds = await mapNamesToOptionValueIds(matchedProduct, values);
            if (mappedIds?.length) {
                variant = await lookupViaSectionId(matchedProduct, mappedIds);
            }
        }

        if (!variant) {
            variant = await lookupViaProductJs(matchedProduct, values);
        }

        if (seq !== selectVariantSeq[side]) return;

        if (!variant) {
            console.warn('Could not resolve variant', {
                side,
                values: {
                    option1: values.option1,
                    option2: values.option2,
                    option3: values.option3,
                    optionValueIds: values.optionValueIds,
                    axis: values.axis,
                    cylinder: values.cylinder,
                    krzywizna: values.krzywizna,
                    srednica: values.srednica
                },
                handle: matchedProduct.handle,
                embeddedVariants: matchedProduct.variants?.length
            });
        }

        applySelectedVariant(variant, side);
    };

    const queueSelectVariant = (side, changedKey = null) => {
        const values = side === 'right' ? right_values : left_values;
        pendingSelect[side] = (async () => {
            await updateOptionAvailability(side, changedKey);
            readCurrentValuesFromDom(side, values);
            await selectVariant(values, side);
        })().catch((error) => console.warn('queueSelectVariant error', error));
        return pendingSelect[side];
    };

    const bindSide = (selectors, side) => {
        if (selectors) {
            selectors.forEach((selector) => {
                selector.addEventListener('change', () => queueSelectVariant(side));
            });
        }

        const metafieldSelectors = getMetafieldSelectors(side);
        METAFIELD_KEYS.forEach((key) => {
            const selector = metafieldSelectors[key];
            if (!selector) return;
            selector.addEventListener('change', () => queueSelectVariant(side, key));
        });

        queueSelectVariant(side);
    };

    populateAllMetafieldSelectors();
    [right_selectors, left_selectors].forEach((selectors) => {
        if (!selectors) return;
        selectors.forEach((selector) => sortSelectOptions(selector));
    });
    console.log('[custom-variant-selector] init', {
        pageHandle,
        products: products.map((p) => ({
            handle: p.handle,
            high_variant: p.high_variant,
            variants_count: p.variants_count,
            optionCount: (p.options || []).length,
            embeddedVariants: (p.variants || []).length
        })),
        rightOptionSelects: right_selectors?.length,
        leftOptionSelects: left_selectors?.length
    });

    bindSide(right_selectors, 'right');
    bindSide(left_selectors, 'left');

    if (is_both) {
        is_both.addEventListener('change', async () => {
            if (!is_both.checked) return;

            if (left_selectors && right_selectors) {
                left_selectors.forEach((leftSelector, index) => {
                    if (right_selectors[index]) leftSelector.value = right_selectors[index].value;
                });
            }
            if (left_axis && right_axis) left_axis.value = right_axis.value;
            if (left_cylinder && right_cylinder) left_cylinder.value = right_cylinder.value;
            if (left_krzywizna && right_krzywizna) left_krzywizna.value = right_krzywizna.value;
            if (left_srednica && right_srednica) left_srednica.value = right_srednica.value;

            await queueSelectVariant('right');
            readCurrentValuesFromDom('left', left_values);
            Object.assign(left_values, {
                option1: right_values.option1,
                option2: right_values.option2,
                option3: right_values.option3,
                optionValueIds: [...(right_values.optionValueIds || [])],
                axis: right_values.axis,
                cylinder: right_values.cylinder,
                krzywizna: right_values.krzywizna,
                srednica: right_values.srednica
            });
            if (right_selected_variant) {
                applySelectedVariant(right_selected_variant, 'left');
            } else {
                await queueSelectVariant('left');
            }
        });
    }

    const add_to_cart_btn = document.querySelector('buy-button .product-form__add-button');
    if (add_to_cart_btn) {
        add_to_cart_btn.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
                await Promise.all([pendingSelect.right, pendingSelect.left]);
            } catch (err) {}

            readCurrentValuesFromDom('right', right_values);
            await selectVariant(right_values, 'right');

            if (is_both?.checked) {
                if (right_selected_variant) applySelectedVariant(right_selected_variant, 'left');
            } else {
                readCurrentValuesFromDom('left', left_values);
                await selectVariant(left_values, 'left');
            }

            // If right failed but left has the exact same selection, reuse left
            if (!right_input?.value && left_selected_variant && selectionsEqual(right_values, left_values)) {
                applySelectedVariant(left_selected_variant, 'right');
            }

            const right_quantity = parseInt(right_quantity_element?.value, 10) || 0;
            const left_quantity = parseInt(left_quantity_element?.value, 10) || 0;
            const right_variant_id = right_input?.value;
            const left_variant_id = left_input?.value;

            if (!right_variant_id) {
                console.warn('ATC missing right variant', {
                    right_values: {
                        option1: right_values.option1,
                        option2: right_values.option2,
                        option3: right_values.option3,
                        optionValueIds: right_values.optionValueIds,
                        axis: right_values.axis,
                        cylinder: right_values.cylinder
                    },
                    left_values: {
                        option1: left_values.option1,
                        option2: left_values.option2,
                        option3: left_values.option3
                    },
                    left_variant_id: left_input?.value
                });
                alert('Proszę wybrać wariant dla prawego oka.');
                return;
            }

            if (!is_both?.checked && !left_variant_id) {
                alert('Proszę wybrać wariant dla lewego oka.');
                return;
            }

            if (right_quantity <= 0) {
                alert('Nieprawidłowa ilość dla prawego oka.');
                return;
            }

            const data = {
                items: [{
                    id: right_variant_id,
                    quantity: right_quantity,
                    properties: { Oko: 'Prawe' }
                }]
            };

            if (!is_both?.checked) {
                data.items.push({
                    id: left_variant_id,
                    quantity: left_quantity,
                    properties: { Oko: 'Lewe' }
                });
            } else {
                // Same prescription both eyes: still add as right eye only once,
                // or duplicate quantity — current behaviour keeps single line with Prawe
            }

            try {
                const response = await fetch(`${getRoutesRoot()}cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                });
                if (!response.ok) throw new Error('Network response was not ok');
                await response.json();
                document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        button: e.target,
                        variant: null,
                        quantity: is_both?.checked ? right_quantity : (right_quantity + left_quantity),
                        productAdded: true
                    }
                }));
            } catch (error) {
                console.error('Error adding to cart:', error);
                alert('Nie można dodać większej ilości – ograniczona dostępność produktu');
            }
        }, true);
    }
});
